import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "label mb-2"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = {
  key: 1,
  class: "text-danger mt-1"
}
const _hoisted_6 = ["innerHTML"]

import { computed, defineAsyncComponent, PropType } from 'vue';
import { t } from '@/utils/i18nHelper';

// Define the structure of the field prop for better type safety
interface FormField {
  name: string;
  type: string;
  label?: string;
  labelKey?: string;
  placeholder?: string;
  description?: string;
  descriptionKey?: string;
  required?: boolean;
  maxDate?: Date;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
  field: {
    type: Object as PropType<FormField>,
    required: true,
  },
  modelValue: {
    type: [String, Number, Boolean, Date, Object] as PropType<any>,
    default: null,
  },
  showError: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: 'Questo campo è obbligatorio',
  }
},
  emits: ['update:modelValue', 'option-selected'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const processedLabel = computed(() => {
  const currentYear = new Date().getFullYear();
  const params = { 'CURRENT_YEAR-1': currentYear - 1 };
  return t(props.field.labelKey || '', props.field.label || '', params);
});

const processedDescription = computed(() => {
  const currentYear = new Date().getFullYear();
  const params = { 'CURRENT_YEAR-1': currentYear - 1 };
  return t(props.field.descriptionKey || '', props.field.description || '', params);
});

// Map field types from JSON to our Vue components
const componentMap: Record<string, any> = {
  date: defineAsyncComponent(() => import('./DatePicker.vue')),
  select: defineAsyncComponent(() => import('./SelectInput.vue')),
  advanced_select: defineAsyncComponent(() => import('./SearchableSelect.vue')),
  switch: defineAsyncComponent(() => import('./SwitchInput.vue')),
  currency: defineAsyncComponent(() => import('./CurrencyInput.vue')),
  text: defineAsyncComponent(() => import('./TextInput.vue')),
};

const resolveComponent = computed(() => {
  const componentName = props.field.type;
  if (componentName in componentMap) {
    return componentMap[componentName];
  }
  return componentMap.text; 
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.field.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
          _createElementVNode("span", { innerHTML: processedLabel.value }, null, 8, _hoisted_3),
          _cache[2] || (_cache[2] = _createTextVNode()),
          (__props.field.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(resolveComponent.value), {
      field: __props.field,
      modelValue: props.modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event))),
      onOptionSelected: _cache[1] || (_cache[1] = ($event: any) => (emit('option-selected', $event))),
      maxDate: __props.field.type === 'date' && __props.field.maxDate ? __props.field.maxDate : null
    }, null, 40, ["field", "modelValue", "maxDate"])),
    (__props.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true),
    (__props.field.description && !__props.showError)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "form-text mt-2",
          style: {"max-width":"600px"},
          innerHTML: processedDescription.value
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}
}

})